import { render, staticRenderFns } from "./SinkBaseForm.vue?vue&type=template&id=a0f844fc&scoped=true&"
import script from "./SinkBaseForm.vue?vue&type=script&lang=js&"
export * from "./SinkBaseForm.vue?vue&type=script&lang=js&"
import style0 from "./SinkBaseForm.vue?vue&type=style&index=0&id=a0f844fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f844fc",
  null
  
)

export default component.exports